import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { TranslateService } from '@ngx-translate/core';
import { isNil } from 'lodash-es';

import {
  DeviceIds,
  Feature,
  FeatureCommands,
  OtherRoomCommands,
  OtherRoomProperties,
} from '@vi-iot/client';

import { GTMService } from '@services';
import { InstallationFeaturesStore } from '@store';

import { InstallationService } from '../../../../../../services/installation.service';
import { CommissioningService } from '../../../../commissioning/commissioning.service';

@Component({
  selector: 'app-src-other-room',
  templateUrl: './src-other-room.component.html',
  styleUrls: ['./src-other-room.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcOtherRoomComponent {
  @Input() otherRoom: Feature<OtherRoomProperties, OtherRoomCommands>;
  @Input() active: boolean;
  @Input() enabled: boolean;

  get heatingCircuit(): string | null {
    const heatingCircuit = this.otherRoom?.properties?.heatingCircuit?.value;

    return isNil(heatingCircuit) ? null : heatingCircuit.toString();
  }

  constructor(
    public commissioningService: CommissioningService,
    public installationService: InstallationService,
    private installationFeaturesStore: InstallationFeaturesStore,
    private translate: TranslateService,
    private gtmService: GTMService
  ) {}

  toggleOtherRoom(isActive: boolean): void {
    if (!isActive) {
      this.activateOtherRoom();
      this.gtmService.track('onConfirm', 'Activate other room', 'commissioningOverview');
    } else {
      this.deactivateOtherRoom();
      this.gtmService.track('onConfirm', 'Deactivate other room', 'commissioningOverview');
    }
  }

  cancelToggleOtherRoom(): void {
    this.gtmService.track('onCancel', 'Toggle other room', 'commissioningOverview');
  }

  onOtherRoomSwitchChange(otherRoomToggle: MatSlideToggle): void {
    otherRoomToggle.toggle();
  }

  private activateOtherRoom(): void {
    this.installationFeaturesStore.updateFeature(
      this.otherRoom.feature,
      null,
      null,
      '',
      FeatureCommands.activate,
      null,
      DeviceIds.RoomControl,
      {
        successMessage: this.translate.instant('+INSTALLATIONS.SRC.OTHER_ROOM.ACTIVATE_SUCCESS'),
      }
    );
  }

  private deactivateOtherRoom(): void {
    this.installationFeaturesStore.updateFeature(
      this.otherRoom.feature,
      null,
      null,
      '',
      FeatureCommands.deactivate,
      null,
      DeviceIds.RoomControl,
      {
        successMessage: this.translate.instant('+INSTALLATIONS.SRC.OTHER_ROOM.DEACTIVATE_SUCCESS'),
      }
    );
  }
}
